module.exports = __webpack_public_path__ + "static/Справочник_вкладчика-d7221d7d6c74e282844332327b703f3f.pdf";